import { faCalendarWeek, faClapperboardPlay, faMapLocation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Users } from 'lucide-preact';
import { FunctionalComponent } from 'preact';
import { getCurrentUrl, Link } from 'preact-router';
import { useDispatch } from 'react-redux';

import { setProductsPromptModalState } from '@/components/products/ProductsPromptModal/redux/actions';
import { useSelector } from '@/redux/helper';

import style from './style.scss';

const activeClass = (path: string) => (getCurrentUrl().includes(path) ? style.active : undefined);

const MobileTabs: FunctionalComponent = () => {
  const dispatch = useDispatch();
  const logged = useSelector((state) => state.user.logged);

  return (
    <nav className={style.mobileTabs}>
      <ul>
        <li>
          <Link className={activeClass('/highlights')} href="/highlights">
            <FontAwesomeIcon icon={faClapperboardPlay} />
          </Link>
        </li>
        <li>
          <Link className={activeClass('/home')} href="/home">
            <FontAwesomeIcon icon={faMapLocation} />
          </Link>
        </li>
        <li>
          {logged ? (
            <Link className={activeClass('/feed')} href="/feed">
              <Users className="size-6" />
            </Link>
          ) : (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              data-native
              className={activeClass('/feed')}
              onClick={(e) => {
                e.preventDefault();
                dispatch(
                  setProductsPromptModalState({
                    entryPoint: 'mobile-tabs-feed',
                    primaryProductType: 'all-habitats-day-pass',
                    secondaryProductType: 'explorer-pass',
                  }),
                );
              }}
              aria-label="Community Feed"
            >
              <Users className="size-6" />
            </a>
          )}
        </li>
        <li>
          <Link className={activeClass('schedule')} href="/schedule">
            <div className="relative">
              <FontAwesomeIcon icon={faCalendarWeek} />
            </div>
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default MobileTabs;
